import type {RestTypeWithTypename} from '../rest-type-with-typename';
import type {DebtOverviewResponse} from './debt-overview';

export function debtOverviewPatcher(data: DebtOverviewResponse): RestTypeWithTypename<DebtOverviewResponse> {
    return {
        __typename: 'DebtOverviewResponse',
        balanceTimeline: data.balanceTimeline as any,
    };
}
